<template>
  <form :class="`${variant}-login-form`" @submit.prevent="validateFormThenSubmit">
    <div class="display: none;">
      <input name="utf8" type="hidden" value="✓" />
      <input name="authenticity_token" type="hidden" value="csrfToken" />
    </div>
    <Field
      v-for="(field, index) in fieldsArray"
      :ref="field.key"
      :key="index"
      :field="field"
      :model.sync="formData[field.key]"
      :labelStyle="variant == 'account' ? 'label' : 'placeholder'"
      :fieldClass="variant == 'account' ? 'account__field' : ''"
    />
    <div class="field" :class="{ account__field: variant == 'account' }">
      <div class="account-login__helpers-wrap">
        <div class="account-login__helpers">
          <input
            class="field__input"
            v-model="helperCheckbox"
            type="checkbox"
            :id="helperCheckboxId"
          />
          <label
            :class="`field__label field__label--inline field__label--${variant}`"
            @click="onHelperCheckboxClick"
            :for="helperCheckboxId"
            >{{ labelOfHelperCheckbox }}</label
          >
        </div>
        <div class="account-login__helpers" v-show="shouldDisplayForgotPasswordLink">
          <a
            class="account-login__forgot-password account-login__forgot-password--full u-arrow-link u-arrow-link--light"
            :href="paths.passwordReset"
            >{{ $t('checkout.login.forgot_password') }}</a
          >
          <a
            class="account-login__forgot-password account-login__forgot-password--short u-arrow-link u-arrow-link--light"
            :href="paths.passwordReset"
            >{{ $t('checkout.login.forgot_short') }}</a
          >
        </div>
      </div>
    </div>
    <SubmitButton
      ref="submitCta"
      :buttonText="submitButtonText"
      :errorCount="errorCount"
      :isSubmitting="isSubmitting"
      :hasSubmitError="hasSubmitError"
      :errorMessage="errorMessage"
      :fieldClass="variant == 'account' ? 'account__field' : 'field--submit-login'"
      :ctaModifiers="submitCtaModifiers"
      ctaId="checkout-as-loggedin-user"
    />
  </form>
</template>

<script>
import LoginForm from './LoginForm'

export default LoginForm
</script>

<style scoped lang="scss">
.account-login-form /deep/ {
  .mandatory-mark {
    display: none;
  }

  .account-login__forgot-password {
    color: $color-account-dark-link;

    &:hover,
    &:hover:before,
    &:focus,
    &:focus:before {
      color: $color-account-dark-link-hover;
    }
  }
}

.field__label--checkout {
  margin-top: $site-gutter / 2 - 1;
  padding-left: 30px !important;
  color: $color-text-light;
}

// scss-lint:disable ImportantRule
.field__label--navigation {
  padding-left: 30px !important;
  font-size: $font-size-small;
  color: $color-text-light;

  @include min-screen($mq-width-tiny) {
    margin-top: 9px;
    margin-bottom: 10px;
  }
}
// scss-lint:enable ImportantRule
</style>
